module.exports = __webpack_public_path__ + "img/niue.a576bb25.svg";